// Contact Page Data

export const contactHeroData = {
  tagline: "CONTACTO",
  title: "Hablemos de tu proyecto",
  subtitle: "Completa el formulario y un especialista se pondrá en contacto contigo en menos de 24 horas."
};

export const contactBenefitsData = [
  {
    id: 1,
    title: "Demo personalizada",
    description: "Te mostramos la plataforma adaptada a tu caso de uso específico."
  },
  {
    id: 2,
    title: "Asesoría sin compromiso",
    description: "Analizamos tus necesidades y te proponemos la mejor solución."
  },
  {
    id: 3,
    title: "Respuesta en 24h",
    description: "Nuestro equipo te contactará en el siguiente día hábil."
  }
];

export const businessTypesData = [
  { value: "distribuidor", label: "Distribuidor IT" },
  { value: "msp", label: "MSP / Proveedor de Servicios Gestionados" },
  { value: "telco", label: "Operador Telco" },
  { value: "reseller", label: "Reseller / Integrador" },
  { value: "enterprise", label: "Empresa / Cliente Final" },
  { value: "otro", label: "Otro" }
];

export const employeeRangesData = [
  { value: "1-10", label: "1-10 empleados" },
  { value: "11-50", label: "11-50 empleados" },
  { value: "51-200", label: "51-200 empleados" },
  { value: "201-500", label: "201-500 empleados" },
  { value: "500+", label: "Más de 500 empleados" }
];

export const interestAreasData = [
  { value: "marketplace", label: "Cloud Marketplace" },
  { value: "contratos", label: "Automatización de Contratos" },
  { value: "facturacion", label: "Facturación y Billing" },
  { value: "wifi", label: "WiFi Administrado" },
  { value: "starlink", label: "Gestión Starlink" },
  { value: "finops", label: "FinOps / Optimización Cloud" },
  { value: "todo", label: "Solución completa" }
];
